const activateOn = (keys) => (handler) => (event) => {
    if (event.target !== event.currentTarget || !keys.includes(event.key)) {
        return;
    }
    event.preventDefault();
    handler(event);
};

export const onButtonKey = activateOn(['Enter', ' ']);

export const onLinkKey = activateOn(['Enter']);
